/**
 * USP-kaarten die op hover uitklappen.
 *
 * De tekst zit in een blok waarvan de hoogte naar nul gaat; GSAP animeert die naar de
 * gemeten hoogte en weer terug. Alleen op apparaten waar hoveren bestaat -- op touch
 * blijft alles gewoon uitgeklapt staan, want daar kun je er niet overheen bewegen.
 *
 * Het inklappen gebeurt vanuit JS en niet vanuit de CSS: zonder JS hoort de tekst
 * leesbaar te zijn.
 */

import gsap from 'gsap';

export default function initUsps() {
  const cards = document.querySelectorAll('[data-usp]');

  if (! cards.length) {
    return;
  }

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (! canHover) {
    return;
  }

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const duration = reduced ? 0 : 0.55;

  cards.forEach((card) => {
    const body = card.querySelector('[data-usp-body]');

    if (! body) {
      return;
    }

    gsap.set(body, { height: 0, autoAlpha: 0, overflow: 'hidden' });

    const tl = gsap.timeline({ paused: true, defaults: { ease: 'power3.out' } })
      .to(body, { height: 'auto', duration })
      .to(body, { autoAlpha: 1, duration: duration * 0.7 }, `-=${duration * 0.6}`);

    const open = () => tl.timeScale(1).play();
    // Iets sneller dicht dan open: dat voelt minder plakkerig als je er langs beweegt.
    const close = () => tl.timeScale(1.3).reverse();

    card.addEventListener('mouseenter', open);
    card.addEventListener('mouseleave', close);
    card.addEventListener('focusin', open);
    card.addEventListener('focusout', close);
  });

  // De gemeten hoogte klopt niet meer als de kolombreedte verandert, dus opnieuw laten
  // meten zodra het scherm van maat verandert.
  let timer;

  window.addEventListener('resize', () => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      cards.forEach((card) => {
        const body = card.querySelector('[data-usp-body]');

        if (body) {
          gsap.set(body, { height: 0, autoAlpha: 0 });
        }
      });
    }, 200);
  });
}
